import { useState } from "react";
import { useParams } from "react-router-dom";
import apiClient from "../api-services/ApiClient";
import { FLW_PUBLIC_KEY, getUser } from "../api-services/process";
import Preloader from "../app-components/preloader/Preloader";
import { UserProfileInterface } from "../app-schemas/user.interface";
import { errorAlert } from "./SweetAlert";

const FlutterwavePaymentButton: React.FC<{
  amount: number;
  plan: string;
  duration: number;
  btnLabel: string;
  currency: string;
}> = ({ amount, plan, duration, btnLabel, currency }) => {
  const user: UserProfileInterface = getUser();
  const { id } = useParams() || {};
  const [loading, setLoading] = useState(false);

  const config = {
    reference: user?.id + new Date().getTime().toString(),
    email: user?.email,
    name: user?.full_name,
    phone: user?.phone_number,
    amount: amount,
    publicKey: FLW_PUBLIC_KEY || "",
    currency: currency === "NGN" ? "NGN" : "USD",
  };

  const PayWithFlutterwave = () => {
    try {
      if (typeof window !== "undefined" && window.FlutterwaveCheckout) {
        window.FlutterwaveCheckout({
          public_key: config.publicKey,
          tx_ref: config.reference,
          amount: config.amount,
          currency: config.currency,
          payment_options: "card",
          redirect_url: "https://honeconnect.com/flutterwave-callback",
          customer: {
            email: config.email,
            phone_number: config.phone,
            name: config.name,
          },
          customizations: {
            title: "HoneConnect",
            description: "Elite Payment",
          },
        });
      } else {
        alert("window not ready, try again later");
      }
    } catch (error) {
      console.error("Error during payment initialization:", error);
      setLoading(false);
      alert(
        "An error occurred while processing the payment. Please try again.",
      );
    }
  };

  const makeSubscription = async () => {
    if (amount === 0) return;

    try {
      setLoading(true);
      const data = {
        connection_request_uuid: id,
        amount: amount,
        reference: config.reference,
        duration: duration,
        plan: plan,
        gateway: "flutterwave",
      };
      const res = await apiClient.post("make-subscription", data);
      if (res.data.payment_reference === config.reference) {
        PayWithFlutterwave();
      }
    } catch (err) {
      errorAlert();
      console.log(err);
      setLoading(false);
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={makeSubscription}
        className="paystack-button paystack-button bg-honeConnectPurple text-white w-full p-3 rounded-lg border-0 text-base mt-4 mb-6 font-medium"
      >
        {btnLabel}
      </button>

      <Preloader loading={loading} />
    </>
  );
};

export default FlutterwavePaymentButton;
